'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useConversationContext } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationTitle = /*#__PURE__*/React.forwardRef(function ConversationTitle(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = useConversationContext();
  void ownerStateProp;
  const Title = slots?.title ?? 'div';
  const titleProps = useSlotProps({
    elementType: Title,
    externalSlotProps: slotProps?.title,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Title, _extends({}, titleProps, {
    children: ownerState.conversation?.title ?? null
  }));
});
if (process.env.NODE_ENV !== "production") ConversationTitle.displayName = "ConversationTitle";